// This list was supplied by client

const WC_CODES = new Map()

WC_CODES.set('0005', 'Farm-Nursery Employees & Drivers')
WC_CODES.set('0008', 'Farm: Gardening & Drivers')
WC_CODES.set('0016', 'Farm: Orchard & Drivers')
WC_CODES.set('0034', 'Farm: Egg or Poultry Producer & Drivers')
WC_CODES.set('0035', 'Farm: Florist & Drivers')
WC_CODES.set('0036', 'Farm: Dairy & Drivers')
WC_CODES.set('0037', 'Farm: NOC & Drivers')
WC_CODES.set('0042', 'Landscape Gardening & Drivers')
WC_CODES.set('0050', 'Farm Machinery Operation & Drivers')
WC_CODES.set('0079', 'Farm: Vineyard & Drivers')
WC_CODES.set('0083', 'Farm: Livestock Raising NOC & Drivers')
WC_CODES.set('0088', 'Aircraft Surcharge')
WC_CODES.set('0106', 'Tree: Pruning & Drivers')
WC_CODES.set('0113', 'Farm: Fish Hatchery & Drivers')
WC_CODES.set('0169', 'Farm: Goat or Sheep Raising & Drivers')
WC_CODES.set('0170', 'Farm: Animal Raising & Drivers')
WC_CODES.set('0251', 'Irrigation Works Operation & Drivers')
WC_CODES.set('0400', 'Cotton Compressing & Drivers')
WC_CODES.set('0401', 'Cotton Gin Operation & Local Mgrs, Drivers')
WC_CODES.set('0908', 'Domestic Workers-Inside-Occasional')
WC_CODES.set('0909', 'Domestic Workers-Outside Occasional')
WC_CODES.set('0912', 'Domestic Workers-Outside-incl priv chauf.')
WC_CODES.set('0913', 'Domestic Workers-Inside')
WC_CODES.set('0917', 'Domestic Service Contractor')
WC_CODES.set('1005', 'Coal Mining-Surface & Drivers')
WC_CODES.set('1164', 'Mining NOC-Underground & Drivers')
WC_CODES.set('1165', 'Mining NOC-Surface & Drivers')
WC_CODES.set('1320', 'Gas/Oil Lease Operator-All Operatns & Drivers')
WC_CODES.set('1322', 'Oil or Gas Well-Cleaning Old Well & Drivers')
WC_CODES.set('1430', 'Smelting-Lead & Drivers')
WC_CODES.set('1438', 'Smelting/Metals/Not Iron or Lead')
WC_CODES.set('1452', 'Ore Milling & Drivers')
WC_CODES.set('1463', 'Asphalt Works & Drivers')
WC_CODES.set('1470', 'Coke Mfg. & Drivers')
WC_CODES.set('1472', 'Distillation-Wood & Drivers')
WC_CODES.set('1624', 'Quarry NOC & Drivers')
WC_CODES.set('1642', 'Lime Mfg.')
WC_CODES.set('1654', 'Quarry-Cement Rock & Drivers')
WC_CODES.set('1655', 'Quarry-Limestone & Drivers')
WC_CODES.set('1699', 'Rock Wool Mfg.')
WC_CODES.set('1701', 'Cement Mfg.')
WC_CODES.set('1710', 'Stone Crushing & Drivers')
WC_CODES.set('1741', 'Flint Grinding & Drivers')
WC_CODES.set('1747', 'Emery Works & Drivers')
WC_CODES.set('1748', 'Abrasive Wheel Mfg. & Drivers')
WC_CODES.set('1803', 'Stone Cutting NOC & Drivers')
WC_CODES.set('1852', 'Asbestos Goods Mfg.')
WC_CODES.set('1853', 'Mica Goods Mfg.')
WC_CODES.set('1860', 'Abrasive Paper Preparation')
WC_CODES.set('1924', 'Cable Mfg.-Not Iron or Steel')
WC_CODES.set('1925', 'Die Casting Mfg.')
WC_CODES.set('2001', 'Cracker Mfg.')
WC_CODES.set('2002', 'Macaroni Mfg.')
WC_CODES.set('2003', 'Bakery & Drivers, Route Supervisors')
WC_CODES.set('2014', 'Feed Mfg.')
WC_CODES.set('2016', 'Breakfast Food Mfg.')
WC_CODES.set('2021', 'Molasses Refining, Blending or Mfg')
WC_CODES.set('2030', 'Beet Sugar Mfg.')
WC_CODES.set('2039', 'Ice Cream Mfg. & Drivers')
WC_CODES.set('2041', 'Confection Mfg.')
WC_CODES.set('2065', 'Milk Products Mfg. NOC')
WC_CODES.set('2070', 'Creamery,Butter,Cheese,Milk,Rte Supvrs & Drvs')
WC_CODES.set('2081', 'Butchering or Slaughtering')
WC_CODES.set('2089', 'Packing House - All Operations')
WC_CODES.set('2095', 'Meat Products Mfg. NOC')
WC_CODES.set('2101', 'Fish Curing')
WC_CODES.set('2105', 'Fruit Packing')
WC_CODES.set('2110', 'Pickle Mfg.')
WC_CODES.set('2111', 'Cannery NOC')
WC_CODES.set('2112', 'Fruit Preserving')
WC_CODES.set('2114', 'Oystermen')
WC_CODES.set('2121', 'Brewery & Drivers')
WC_CODES.set('2130', 'Distillery-Spirituous Liquor')
WC_CODES.set('2131', 'Spirituous Liquor Bottling')
WC_CODES.set('2143', 'Fruit Juice Mfg., Winery')
WC_CODES.set('2150', 'Ice Mfg.')
WC_CODES.set('2156', 'Bottling-Not Carb. Liquids & Rt. Spvs, Driver')
WC_CODES.set('2157', 'Bvg. Mfg. & Bottling NOC & Rte. Supvrs, Drive')
WC_CODES.set('2172', 'Cigarette Mfg.')
WC_CODES.set('2174', 'Tobacco Warehouse')
WC_CODES.set('2177', 'Cigar Mfg.')
WC_CODES.set('2211', 'Cotton Batting Mfg.')
WC_CODES.set('2220', 'Carpet Mfg.-Jute or Hemp')
WC_CODES.set('2286', 'Yarn Mfg.-Wool')
WC_CODES.set('2288', 'Felting Mfg.')
WC_CODES.set('2300', 'Plush Mfg.')
WC_CODES.set('2302', 'Silk Thread or Yarn Mfg.')
WC_CODES.set('2305', 'Textile Fiber Mfg.')
WC_CODES.set('2361', 'Hosiery Mfg.')
WC_CODES.set('2362', 'Knit Goods Mfg. NOC')
WC_CODES.set('2380', 'Braid, Fringe, Net, Wedding Mfg.')
WC_CODES.set('2386', 'Lace Mfg.')
WC_CODES.set('2388', 'Embroidery Mfg.')
WC_CODES.set('2402', 'Carpet Mfg. NOC')
WC_CODES.set('2413', 'Textile Finishing')
WC_CODES.set('2416', 'Yarn & Thread Dyeing or Finishing')
WC_CODES.set('2417', 'Cloth Printing')
WC_CODES.set('2501', 'Clothing Mfg.')
WC_CODES.set('2503', 'Dressmaking-Custom')
WC_CODES.set('2534', 'Hair Goods Mfg.')
WC_CODES.set('2570', 'Matress & Box Spring Mfg.')
WC_CODES.set('2576', 'Tent & Awning Mfg.-Shop')
WC_CODES.set('2578', 'Bag Mfg.-Cloth')
WC_CODES.set('2585', 'Laundry NOC & Rt. Supvrs Carpt Cleanng Driver')
WC_CODES.set('2586', 'Cleaning & Dyeing & Rt. Supvrs, Drivers')
WC_CODES.set('2587', 'Toilet Supply Co. & Rt. Supervisors, Drivers')
WC_CODES.set('2589', 'Laundry,Dry Clean-Retail-Rt. Supvrs. Drivers')
WC_CODES.set('2600', 'Fur Mfg.')
WC_CODES.set('2623', 'Leather Mfg.-Patent or Enamel')
WC_CODES.set('2651', 'Gasket/Washer Mfg')
WC_CODES.set('2660', 'Boot & Shoe Mfg. NOC')
WC_CODES.set('2670', 'Glove Mfg.-Leather or Textile')
WC_CODES.set('2683', 'Luggage Mfg.')
WC_CODES.set('2688', 'Leather Goods Mfg. NOC')
WC_CODES.set('2702', 'Dam/Lock Const-Timber Cutting, Remvl & Driver')
WC_CODES.set('2710', 'Sawmill')
WC_CODES.set('2714', 'Veneer Mfg.')
WC_CODES.set('2731', 'Planning or Molding Mill')
WC_CODES.set('2735', 'Furniture Stock Mfg.')
WC_CODES.set('2741', 'Barrel Stock Mfg.')
WC_CODES.set('2747', 'Barrel Assembly')
WC_CODES.set('2759', 'Box or Box Shook Mfg.')
WC_CODES.set('2790', 'Pattern Making NOC')
WC_CODES.set('2802', 'Carpentry-Shop Only-& Drivers')
WC_CODES.set('2812', 'Cabinet Works-with Power Machinery')
WC_CODES.set('2835', 'Brush or Broom Assembly')
WC_CODES.set('2836', 'Brush or Broom Mfg. Assembly')
WC_CODES.set('2841', 'Wood Turned Products Mfg. NOC')
WC_CODES.set('2881', 'Furniture Assembly-Wood')
WC_CODES.set('2883', 'Furniture & Cabinet Mfg.-Wood-NOC')
WC_CODES.set('2913', 'Willow & Rattan Products Mfg.')
WC_CODES.set('2915', 'Veneer Products Mfg.')
WC_CODES.set('2916', 'Veneer Products Mfg.-No Veneer Mfg.')
WC_CODES.set('2923', 'Musical Instrument Mfg.-Wood-NOC')
WC_CODES.set('2942', 'Crayon & Pencil Mfg.')
WC_CODES.set('2960', 'Wood Preserving & Drivers')
WC_CODES.set('3004', 'Iron/Steel Mfg.-Steel Making & Drivers')
WC_CODES.set('3018', 'Iron/Steel Mfg.-Rolling Mill NOC & Drivers')
WC_CODES.set('3022', 'Pipe Mfg. NOC & Drivers')
WC_CODES.set('3027', 'Lead Works & Drivers')
WC_CODES.set('3028', 'Pipe or Tube Mfg.-Iron or Steel-& Drivers')
WC_CODES.set('3030', 'Iron/Steel Fabric., Works, Struc. & Drivers')
WC_CODES.set('3040', 'Iron/Steel Fabric., Wrks, Ornamental & Driver')
WC_CODES.set('3041', 'Iron/Steel Fabrication/Iron Wrks')
WC_CODES.set('3042', 'Elevator & Escalator Mfg.')
WC_CODES.set('3064', 'Sign Mfg.-Metal')
WC_CODES.set('3066', 'Sheet Metal Work-Shop')
WC_CODES.set('3076', 'Furniture Mfg.-Metal')
WC_CODES.set('3081', 'Foundry-Ferrous-NOC')
WC_CODES.set('3082', 'Foundry-Steel Casting')
WC_CODES.set('3085', 'Foundry-Nonferrous')
WC_CODES.set('3091', 'Enameled Ironware Mfg.')
WC_CODES.set('3110', 'Tool Mfg.-Drop or Machine Forged-NOC')
WC_CODES.set('3111', 'Blacksmith')
WC_CODES.set('3113', 'Tool Mfg.-Not Drop or Machine Forged-NOC')
WC_CODES.set('3114', 'Tool Mfg,Include.Tool & Die Making')
WC_CODES.set('3118', 'Saw Mfg.')
WC_CODES.set('3119', 'Needle/Pen Point Mfg')
WC_CODES.set('3122', 'Cutlery Mfg. NOC')
WC_CODES.set('3126', 'Tool Mfg.')
WC_CODES.set('3131', 'Fastener Mfg.-Metal')
WC_CODES.set('3132', 'Nut & Bolt Mfg')
WC_CODES.set('3145', 'Screw Mfg.')
WC_CODES.set('3146', 'Hardware Mfg. NOC')
WC_CODES.set('3169', 'Stove Mfg.')
WC_CODES.set('3175', 'Heater Mfg.')
WC_CODES.set('3179', 'Electrical Apparatus Mfg. NOC')
WC_CODES.set('3180', 'Light Fixtures Mfg.')
WC_CODES.set('3188', 'Plumbers Supplies Mfg. NOC')
WC_CODES.set('3220', 'Can Mfg.')
WC_CODES.set('3223', 'Lamp Mfg. NOC')
WC_CODES.set('3224', 'Enamel Ware Mfg.')
WC_CODES.set('3227', 'Aluminum Ware Mfg.')
WC_CODES.set('3240', 'Wire Rope Mfg.-Iron or Steel')
WC_CODES.set('3241', 'Wire Drawing-Iron or Steel')
WC_CODES.set('3255', 'Wire Cloth Mfg.')
WC_CODES.set('3257', 'Wire Goods Mfg. NOC')
WC_CODES.set('3270', 'Nail Mfg.')
WC_CODES.set('3300', 'Bed Spring Mfg.')
WC_CODES.set('3303', 'Spring Mfg.')
WC_CODES.set('3307', 'Heat-Treating')
WC_CODES.set('3315', 'Brass & Copper Goods Mfg.')
WC_CODES.set('3334', 'Tinfoil Mfg.')
WC_CODES.set('3336', 'Type Foundries')
WC_CODES.set('3365', 'Welding NOC & Drivers')
WC_CODES.set('3372', 'Electroplating')
WC_CODES.set('3373', 'Galvanizing/Tinning')
WC_CODES.set('3383', 'Jewelry Mfg.')
WC_CODES.set('3385', 'Clock & Watch Mfg.')
WC_CODES.set('3400', 'Metal Goods Mfg. NOC')
WC_CODES.set('3507', 'Machinery Mfg.')
WC_CODES.set('3515', 'Textile Machinery Mfg.')
WC_CODES.set('3548', 'Bookbinding Machine Mfg.')
WC_CODES.set('3559', 'Confection Machine Mfg.')
WC_CODES.set('3565', 'Typewriter Mfg.')
WC_CODES.set('3574', 'Computing Machine Mfg. NOC')
WC_CODES.set('3581', 'Carburetor Mfg.')
WC_CODES.set('3612', 'Engine Mfg. NOC')
WC_CODES.set('3620', 'Boilermaking')
WC_CODES.set('3629', 'Precision Machines Parts')
WC_CODES.set('3632', 'Machine Shop NOC')
WC_CODES.set('3634', 'Automatic Sprinkler Head Mfg.')
WC_CODES.set('3635', 'Gear Mfg. or Grinding')
WC_CODES.set('3638', 'Ball Bearing Mfg.')
WC_CODES.set('3639', 'Explvs./Ammunition Mfg.-Projectile/Shell Mfg.')
WC_CODES.set('3642', 'Battery Mfg.-Dry')
WC_CODES.set('3643', 'Electric Power Equipment Mfg.')
WC_CODES.set('3647', 'Battery Mfg.-Storage')
WC_CODES.set('3648', 'Auto Lighting/Ignition/Starters')
WC_CODES.set('3681', 'Radio Apparatus Mfg. or Assembly NOC')
WC_CODES.set('3685', 'Instrument Mfg. NOC')
WC_CODES.set('3719', 'Oil Still Erection or Repair')
WC_CODES.set('3724', 'Millwright Work NOC & Drivers')
WC_CODES.set('3726', 'Boiler Install & Repair')
WC_CODES.set('3726U', 'Boiler Install & Repair (USLHW)')
WC_CODES.set('3803', 'Automobile Wheel Mfg.')
WC_CODES.set('3807', 'Automobile Radiator Mfg.')
WC_CODES.set('3808', 'Automobile Mfg. or Assembly')
WC_CODES.set('3821', 'Automobile Dismantling & Drivers')
WC_CODES.set('3822', 'Auto,Bus,Truck/Trailer Mfg.-Die Pressed Steel')
WC_CODES.set('3824', 'Automobile,Bus,Truck/Trailer Body Mfg.-NOC')
WC_CODES.set('3826', 'Aircraft Engine Mfg.')
WC_CODES.set('3827', 'Automobile Engine Mfg')
WC_CODES.set('3830', 'Airplane Mfg.')
WC_CODES.set('3851', 'Motorcycle Mfg. or Assembly')
WC_CODES.set('3865', 'Bicycle Mfg. or Assembly')
WC_CODES.set('3881', 'Car Mfg.-Railroad-& Drivers')
WC_CODES.set('4000', 'Clay,Gravel,Sand,Shale Digging & Drivers')
WC_CODES.set('4021', 'Brick Mfg. NOC & Drivers')
WC_CODES.set('4024', 'Brick Mfg.-Fire or Enameled-& Drivers')
WC_CODES.set('4034', 'Concrete Productions Mfg. & Drivers')
WC_CODES.set('4036', 'Plasterboard Mfg. & Drivers')
WC_CODES.set('4038', 'Dress Form Mfg.')
WC_CODES.set('4053', 'Pottery Mfg.-China or Tableware')
WC_CODES.set('4061', 'Pottery Mfg.-Earthenware-Hand Molded/Cast')
WC_CODES.set('4062', 'Pottery Mfg.-Porcelain Ware-Press Forming')
WC_CODES.set('4101', 'Glass Mfg.-Polished Plate/Rolled & Drivers')
WC_CODES.set('4111', 'Glassware Mfg.-No Automatic Blowing Machines')
WC_CODES.set('4112', 'Radio Television Device Mfg.')
WC_CODES.set('4113', 'Glass Mfg.-Cut')
WC_CODES.set('4114', 'Glassware Mfg. NOC')
WC_CODES.set('4130', 'Glass Merchant')
WC_CODES.set('4131', 'Mirror Mfg.')
WC_CODES.set('4133', 'Glass Window Mfg.')
WC_CODES.set('4150', 'Computer Chip Mfg.')
WC_CODES.set('4206', 'Pulp Mfg.-Ground Wood')
WC_CODES.set('4207', 'Pulp Mfg.-Chemical')
WC_CODES.set('4229', 'Printing')
WC_CODES.set('4239', 'Paper Mfg.')
WC_CODES.set('4240', 'Box Mfg.-Set-up Paper')
WC_CODES.set('4243', 'Box Mfg.-Folding Paper-NOC')
WC_CODES.set('4244', 'Corrugated Container Mfg.')
WC_CODES.set('4250', 'Paper Corrugating or Laminating')
WC_CODES.set('4251', 'Typewriter Ribbon Mfg.')
WC_CODES.set('4263', 'Fiber Goods Mfg.')
WC_CODES.set('4273', 'Bag Mfg.-Paper')
WC_CODES.set('4279', 'Paper Goods Mfg. NOC')
WC_CODES.set('4282', 'Pattern Mfg.')
WC_CODES.set('4283', 'Roofing Paper or Felt Preparation')
WC_CODES.set('4299', 'Printing')
WC_CODES.set('4301', 'Wallpaper Mfg.')
WC_CODES.set('4304', 'Newspaper Publishing')
WC_CODES.set('4307', 'Bookbinding')
WC_CODES.set('4308', 'Linotype Composition')
WC_CODES.set('4350', 'Electrotyping')
WC_CODES.set('4351', 'Photoengraving')
WC_CODES.set('4352', 'Engraving')
WC_CODES.set('4360', 'Motion Pict.-Negs. & All Subsequent Oper.')
WC_CODES.set('4361', 'Photo-All Employees & Clerical, Sales, Driver')
WC_CODES.set('4362', 'Motion Picture-Film Exchange & Clerical')
WC_CODES.set('4410', 'Rubber Goods Mfg. NOC')
WC_CODES.set('4417', 'Shoe & Boot Mfg.-Rubber')
WC_CODES.set('4420', 'Rubber Tire Mfg.')
WC_CODES.set('4431', 'Phonograph Record Mfg.')
WC_CODES.set('4432', 'Fountain Pen, Pencil & Pen Mfg.')
WC_CODES.set('4439', 'Lacquer Mfg.')
WC_CODES.set('4452', 'Ivory Goods Mfg.')
WC_CODES.set('4459', 'Plastics Mfg.-Sheets, Rods or Tubes')
WC_CODES.set('4470', 'Wire Insulating')
WC_CODES.set('4484', 'Plastics Mfg.-Molded Products NOC')
WC_CODES.set('4493', 'Leather Mfg.-Imitation')
WC_CODES.set('4511', 'Analytical Chemist')
WC_CODES.set('4512', 'Biomedical Research Labs')
WC_CODES.set('4557', 'Ink Mfg.')
WC_CODES.set('4558', 'Paint Mfg.')
WC_CODES.set('4561', 'Varnishing Mfg.- Oleoresinous')
WC_CODES.set('4568', 'Borax,Potash & Salt Prod./Refining & Drivers')
WC_CODES.set('4581', 'Phosphate Works & Drivers')
WC_CODES.set('4583', 'Fertilizer Mfg. & Drivers')
WC_CODES.set('4611', 'Cosmetics Mfg.-Not Mfg. Ingredients')
WC_CODES.set('4635', 'Acetylene Gas Mfg. & Drivers')
WC_CODES.set('4653', 'Glue Mfg. & Drivers')
WC_CODES.set('4665', 'Rendering Works NOC & Drivers')
WC_CODES.set('4670', 'Cottonseed Oil Mfg.-Mech./Solvent & Drivers')
WC_CODES.set('4683', 'Oil Mfg.-Vegetable-NOC')
WC_CODES.set('4686', 'Oil Mfg.-Vegetable-Solvent Extraction Process')
WC_CODES.set('4692', 'Dental Laboratory')
WC_CODES.set('4693', 'Surgical & Pharmaceutical Goods Mfg. NOC')
WC_CODES.set('4703', 'Corn Products Mfg.')
WC_CODES.set('4717', 'Butter Substitute Mfg.')
WC_CODES.set('4720', 'Soap Mfg.')
WC_CODES.set('4740', 'Gasoline & Oil Recovery & Drivers')
WC_CODES.set('4741', 'Asphalt Distilling or Refining & Drivers')
WC_CODES.set('4751', 'Synthetic Rubber Mfg.')
WC_CODES.set('4770', 'Explosive/Amntn Mfg.-Bag Loading & Drivers')
WC_CODES.set('4773', 'Expls./Amntn. Mfg.-High Expls. Mfg. & Drivers')
WC_CODES.set('4774', 'Expls/Amntn Mfg.-Smkless Powder Mfg. & Driver')
WC_CODES.set('4775', 'Expls/Amntn Mfg.-Shell Case Loading & Drivers')
WC_CODES.set('4776', 'Expls/Amntn Mfg.-Proj/Grenade Loading & Drive')
WC_CODES.set('4777', 'Blasting Agents-Preparation/Dist. & Drivers')
WC_CODES.set('4779', 'Expls/Amntn Mfg.-Cap/Detnt Assembly & Drivers')
WC_CODES.set('4799', 'Expls/Amntn Mfg.-Black Powder Mfg. & Drivers')
WC_CODES.set('4804', 'Synthetic Rubber Intermediate Mfg.')
WC_CODES.set('4811', 'Ammonium Nitrate Mfg.')
WC_CODES.set('4812', 'Ammonia Mfg.')
WC_CODES.set('4815', 'Acid Mfg.')
WC_CODES.set('4825', 'Pharmaceutical Mfg.')
WC_CODES.set('4828', 'Chemical Blending or mixing NOC')
WC_CODES.set('4829', 'Vitriol Mfg.')
WC_CODES.set('4902', 'Sporting Goods Mfg. NOC')
WC_CODES.set('4923', 'Audio or Visual Recording Media Mfg.')
WC_CODES.set('5020', 'Ceiling Instln-Suspnd Acoustical Grid Type')
WC_CODES.set('5022', 'Masonry NOC')
WC_CODES.set('5037', 'Paintg-Metal Structures-Over 2 Strs & Drivers')
WC_CODES.set('5040', 'Iron or Steel-Erection-Exterior')
WC_CODES.set('5057', 'Iron or Steel-Erection NOC')
WC_CODES.set('5059', 'Iron/Steel-Erctn-Frame Strcts Not Ovr 2 Strs')
WC_CODES.set('5069', 'Iron/Steel-Erect-Frame Strct Nt Ovr 2 Stories')
WC_CODES.set('5102', 'Iron or Steel-Door or Sash Erection-Metal')
WC_CODES.set('5146', 'Furniture & Fixtures Installation-NOC')
WC_CODES.set('5160', 'Elevator Erection or Repair')
WC_CODES.set('5183', 'Plumbing NOC & Drivers')
WC_CODES.set('5188', 'Automatic Sprinkler Installation & Drivers')
WC_CODES.set('5190', 'Electrical Wiring-within Buildings & Drivers')
WC_CODES.set('5191', 'Office Machine Installation & Repair')
WC_CODES.set('5192', 'Vending Machines-Instn,Srvc/Rpr&Slprn, Driver')
WC_CODES.set('5213', 'Concrete Construction NOC')
WC_CODES.set('5215', 'Concrete Work-Construction of Residence')
WC_CODES.set('5221', 'Concrete or Cement Work-Floors, Driveways, Yards or Sidewalks & Drvrs')
WC_CODES.set('5222', 'Concrete Construction Bridges or Culverts')
WC_CODES.set('5223', 'Swimming Pool Construction-& Drivers')
WC_CODES.set('5348', 'Tile Work-Inside')
WC_CODES.set('5402', 'Greenhouse Erection-All Operations')
WC_CODES.set('5403', 'Carpentry NOC')
WC_CODES.set('5437', 'Carpentry-Instaltn Cabinet Work Interior Trim')
WC_CODES.set('5443', 'Lathing & Drivers')
WC_CODES.set('5445', 'Wallboard Install-w/in Bldgs/Drivers')
WC_CODES.set('5462', 'Glazier-Away from Shop & Drivers')
WC_CODES.set('5472', 'Asbestos Contr-Pipe/Boiler Wrk Exclusv')
WC_CODES.set('5473', 'Asbestos Contractor NOC & Drivers')
WC_CODES.set('5474', 'Painting/Paper Hanging NOC & Drivers')
WC_CODES.set('5478', 'Carpet, Linoleum, Vinyl Installation')
WC_CODES.set('5479', 'Insulation Work NOC & Drivers')
WC_CODES.set('5480', 'Plastering NOC & Drivers')
WC_CODES.set('5491', 'Paperhanging & Drivers')
WC_CODES.set('5506', 'St/Rd Construction-Paving/Repaving & Drivers')
WC_CODES.set('5507', 'St/Rd Construction-Subsurface Work & Drivers')
WC_CODES.set('5508', 'St/Rd Construction-Rock Excavating & Drivers')
WC_CODES.set('5515', 'Street & Road Construction & Drivers')
WC_CODES.set('5535', 'Sheet Metal Work-Installation & Drivers')
WC_CODES.set('5537', 'Heating, Ventilation, AC & Refrig-Install, Serv, Repair & Drivers')
WC_CODES.set('5551', 'Roofing-All Kinds & Drivers')
WC_CODES.set('5606', 'Contrctr-Exectv Spvsr/Constr Superintendent')
WC_CODES.set('5610', 'Cleaner-Debris Removal')
WC_CODES.set('5645', 'Carpentry-Detached Dwellings')
WC_CODES.set('5651', 'Carpentry-Dwellings-3 Stories or Less')
WC_CODES.set('5703', 'Building Raising or Moving & Drivers')
WC_CODES.set('5705', 'Salvage Operation - No Wrecking')
WC_CODES.set('5951', 'Antitoxin Serum & Virus Mfg. & Drivers')
WC_CODES.set('6003', 'Pile Driving & Drivers')
WC_CODES.set('6005', 'Jetty Construction-All Operations & Drivers')
WC_CODES.set('6017', 'Dam/Lock Const.-Concrete Work-All Operations')
WC_CODES.set('6018', 'Dam/Lock Const.-earth Moving-All Oper & Drive')
WC_CODES.set('6045', 'Levee Construction-All Operations & Drivers')
WC_CODES.set('6204', 'Drilling NOC & Drivers')
WC_CODES.set('6206', 'Oil/Gas Well-Acidizing-All Employees & Driver')
WC_CODES.set('6213', 'Oil/Gas Well Specialty Tool Oper NOC')
WC_CODES.set('6214', 'Oil/Gas Well-Perforating of Casings')
WC_CODES.set('6216', 'Oil Lease Work NOC-by Contractors & Drivers')
WC_CODES.set('6217', 'Excavation NOC & Drivers')
WC_CODES.set('6229', 'Drainage & Irrigation System Const & Drivers')
WC_CODES.set('6233', 'Oil/Gas Pipeline Construction & Drivers')
WC_CODES.set('6235', 'Drilling Oil Wells & Drivers')
WC_CODES.set('6236', 'Oil/Gas Well-Installation of Casing/Drivers')
WC_CODES.set('6237', 'Oil/Gas Well-Instrmt Loggen/Survy Wrk & Drive')
WC_CODES.set('6251', 'Tunneling-Not Pneumatic-All Operations')
WC_CODES.set('6252', 'Cofferdam Work-Not Pneumatic-All Operations')
WC_CODES.set('6260', 'Tunneling-Pneumatic-All Operations')
WC_CODES.set('6306', 'Sewer Construction-All Operations & Drivers')
WC_CODES.set('6319', 'Steam Water & Gas Main Construction & Drivers')
WC_CODES.set('6325', 'Conduit Const-for Cables/Wires-Drivers')
WC_CODES.set('6400', 'Fence Erection-Metal')
WC_CODES.set('6504', 'Food Sundries Mfg NOC')
WC_CODES.set('6525', 'Cofferdam Wrk-Not Pneumatic-All Ops')
WC_CODES.set('6801F', 'Boat Building-Wood-NOC & Drivers-U.S. Act')
WC_CODES.set('6811', 'Boat Building-Wood-NOC & Drivers St Act Only')
WC_CODES.set('6824F', 'Boatbuilding')
WC_CODES.set('6826F', 'Marina & Drivers-U.S. Act')
WC_CODES.set('6834', 'Boat Building or Repair & Drivers')
WC_CODES.set('6836', 'Marina & Drivers-State Act Only')
WC_CODES.set('6843F', 'Shipbuilding-Iron/Steel-NOC & Drivers-US Act')
WC_CODES.set('6845F', 'Ship Building-Naval & Drivers')
WC_CODES.set('6854', 'Ship Bldg-Iron/Steel-NOC & Drivers-St Act Ony')
WC_CODES.set('6872', 'Cleaning-all operations & drivers')
WC_CODES.set('6872F', 'Marine Railway Operation & Drivers U.S. Act')
WC_CODES.set('6874F', 'Painting-Ship Hulls-U.S. Act')
WC_CODES.set('6882', 'Ship Repair Conversion-All Ops')
WC_CODES.set('6884', 'Painting Ship Hull-State Act Only')
WC_CODES.set('7047', 'Vessels, NOC (Program II-USL Act Benefits)')
WC_CODES.set('7050', 'Boatbuilding or repair')
WC_CODES.set('7131', 'Tugboats')
WC_CODES.set('7133', 'Railroad Oper-NOC-All Employees & Drivers')
WC_CODES.set('7219', 'Trucking-NOC-All Employees & Drivers')
WC_CODES.set('7222', 'Trucking-Oil Field Equipment-All Empl & Drive')
WC_CODES.set('7228', 'Trucking - Local Hauling ONLY, All Employees & Drivers')
WC_CODES.set('7229', 'Trucking - Long Distance Hauling, All Employees &  Drivers')
WC_CODES.set('7230', 'Trucking-Parcel Delivery-All Empl & Drivers')
WC_CODES.set('7231', 'Trucking-Mail/Parcel/Package Delivery')
WC_CODES.set('7232', 'Mail,parcel, or pkg delivery')
WC_CODES.set('7309F', 'Stevedoring NOC')
WC_CODES.set('7313', 'Ore Dock Operation & Stevedoring')
WC_CODES.set('7313F', 'Coal Dock Operation & Stevedoring')
WC_CODES.set('7317', 'Stevedoring by Hand or Hand Trks Excl')
WC_CODES.set('7317F', 'Stevedoring-by Hand/Hand Trucks Exclusively')
WC_CODES.set('7323F', 'Stevedoring-Explosive Materials')
WC_CODES.set('7327F', 'Stevedoring-Containerized Freight & Drivers')
WC_CODES.set('7350F', 'Freight Haandling NOC: U.S. Act')
WC_CODES.set('7360', 'Freight Handling NOC-State Act Only')
WC_CODES.set('7370', 'Limo Co: All Other Empl & Drivers-Nonschedule')
WC_CODES.set('7380', 'Chauffers & Drivers NOC')
WC_CODES.set('7382', 'Limo Co: All Other Empl & Drivers-Scheduled')
WC_CODES.set('7390', 'Beer & Ale Dealer-Wholesale & Drivers')
WC_CODES.set('7403', 'Air Carriers-Scheduled-All Others & Dr')
WC_CODES.set('7405', 'Air Carrier-Scheduled or Supplemental')
WC_CODES.set('7409', 'Aerial Application: Flying Crew')
WC_CODES.set('7418', 'Aircraft: Patrol, Photography')
WC_CODES.set('7420', 'Aircraft: Public Exhibition')
WC_CODES.set('7421', 'Aircraft: Transportation of Personnel')
WC_CODES.set('7422', 'Aircraft: NOC-Other Than Helicopters')
WC_CODES.set('7423', 'Airport/Heliport Operation-All Empl & Drivers')
WC_CODES.set('7425', 'Aircraft: Helicopters NOC')
WC_CODES.set('7431', 'Air Carrier-Commuter')
WC_CODES.set('7502', 'Gas Works & Drivers')
WC_CODES.set('7515', 'Oil/Gas Pipeline Operation & Drivers')
WC_CODES.set('7520', 'Waterworks Operation & Drivers')
WC_CODES.set('7538', 'Electric Powerline Construction & Drivers')
WC_CODES.set('7539', 'Steam & Elec Power Co. NOC-All Empl & Drivers')
WC_CODES.set('7540', 'Electric Cooperative-REA-All Empl & Drivers')
WC_CODES.set('7580', 'Sewage Disposal Plant Operation & Drivers')
WC_CODES.set('7590', 'Garbage Works')
WC_CODES.set('7605', 'Burglar/Fire Alarm Install/Repair-Driver')
WC_CODES.set('7610', 'TV/Radio Broadcsting Station')
WC_CODES.set('7611', 'Telephone/Cable TV Line Install')
WC_CODES.set('7612', 'Tele/Telegraph Co-All Other Emp & Drivers')
WC_CODES.set('7613', 'Telephone Line Const & Drivers')
WC_CODES.set('7704', 'Firefighters & Drivers')
WC_CODES.set('7720', 'Detective or Patrol Agency & Drivers')
WC_CODES.set('7855', 'RR Constr/Laying Tracks or Maintenance')
WC_CODES.set('8001', 'Store: Florist & Drivers')
WC_CODES.set('8002', 'Auto Rental Co-All Other Empl')
WC_CODES.set('8006', 'Store: Retail-Food')
WC_CODES.set('8008', 'Store: Clothing Wearing Apparel/Dry Goods Rtl')
WC_CODES.set('8010', 'Store: Hardware')
WC_CODES.set('8013', 'Store: Jewelry')
WC_CODES.set('8015', 'Quick Printing-copying')
WC_CODES.set('8017', 'Store: Retail NOC')
WC_CODES.set('8018', 'Store: Wholesale NOC')
WC_CODES.set('8021', 'Store: Meat, Fish/Poultry Dealer-Wholesale')
WC_CODES.set('8031', 'Cold Storage Locker-Frozen Foods')
WC_CODES.set('8032', 'Store:Clothing,Wearing Apparel/Dry Goods')
WC_CODES.set('8033', 'Store: Supermarket')
WC_CODES.set('8039', 'Store: Department-Retail')
WC_CODES.set('8044', 'Store: Furniture & Drivers')
WC_CODES.set('8045', 'Drug-retail')
WC_CODES.set('8046', 'Store: Auto Accessories-Retail-NOC & Drivers')
WC_CODES.set('8047', 'Store: Drug-Wholesale')
WC_CODES.set('8050', 'Store: Five & Ten Cent')
WC_CODES.set('8058', 'Home Improvement Center-Store Employees')
WC_CODES.set('8061', 'Store: Grocery-Convenience Retail')
WC_CODES.set('8072', 'Book,record,compact disc,software')
WC_CODES.set('8102', 'Seed Merchant')
WC_CODES.set('8103', 'Cotton Merchant/Storage/Wool')
WC_CODES.set('8105', 'Store-Leather Dealer')
WC_CODES.set('8106', 'Iron & Steel Merchant & Drivers')
WC_CODES.set('8107', 'Machinery Dealer NOC & Drivers')
WC_CODES.set('8111', "Plumbers' Supplies Dealer & Drivers")
WC_CODES.set('8116', 'Farm Machinery Dealer-All Operations & Driver')
WC_CODES.set('8203', 'Ice Dealer & Drivers')
WC_CODES.set('8204', 'Building Material Yard & Local Mgrs, Drivers')
WC_CODES.set('8209', 'Vegetable Packing & Drivers')
WC_CODES.set('8215', 'Feed & Grain Dealer & Local Mgrs, Drivers')
WC_CODES.set('8227', 'Construction or Erection Permanent Yard')
WC_CODES.set('8232', 'Bldg Material Dealer-All Other Empls & Driver')
WC_CODES.set('8233', 'Coal Merchant & Local Managers, Drivers')
WC_CODES.set('8235', 'Sash Dealer & Drivers')
WC_CODES.set('8263', 'Junk Dealer & Drivers')
WC_CODES.set('8264', 'Bottle Dealer-Used & Drivers')
WC_CODES.set('8265', 'Scrap Dealer & Drivers')
WC_CODES.set('8279', 'Stable & Drivers')
WC_CODES.set('8288', 'Livestock Sales Company & Salesperson, Driver')
WC_CODES.set('8291', 'Storage Warehouse-Cold')
WC_CODES.set('8292', 'Warehousing NOC')
WC_CODES.set('8293', 'Furniture Moving & Storage & Drivers')
WC_CODES.set('8304', 'Grain Elevator Operation & Local Mgrs, Dealer')
WC_CODES.set('8350', 'Gasoline Dealer & Drivers')
WC_CODES.set('8380', 'Automobile Service/Repair Center & Drivers')
WC_CODES.set('8381', 'Gasoline Station-Self Service')
WC_CODES.set('8385', 'Automobile Rental Co: Garage Employees')
WC_CODES.set('8392', 'Automobile Parking Lot & Drivers')
WC_CODES.set('8393', 'Automobile Body Repair')
WC_CODES.set('8395', 'Auto Body Repair')
WC_CODES.set('8472', 'Foreign Compensation')
WC_CODES.set('8500', 'Metal Scrap Dealer & Delivery')
WC_CODES.set('8601', 'Architect & Engineer Consulting')
WC_CODES.set('8606', 'Geophysical Explortn Seismic-All Empl & Drive')
WC_CODES.set('8709', 'Steamship Line or Agency')
WC_CODES.set('8709F', 'Stevedoring-Talliers and Checking Clerks')
WC_CODES.set('8710', 'Field Bonded Warehousing-All Empl & Clerical')
WC_CODES.set('8719', 'Inspectors of Merch. on Vessels/Docks')
WC_CODES.set('8720', 'Inspection for Insurance Purposes NOC')
WC_CODES.set('8726F', 'Steamship Line or Agency-Port Empl')
WC_CODES.set('8742', 'Salespersons-Outside')
WC_CODES.set('8745', 'News Agent-Not Retail Dealr & Salepersns Driv')
WC_CODES.set('8748', 'Automobile Salespersons')
WC_CODES.set('8755', 'Labor Union-All Employees')
WC_CODES.set('8800', 'Mailing Company & Clerical')
WC_CODES.set('8803', 'Accountant & auditor Traveling')
WC_CODES.set('8810', 'Clerical Office Employees NOC')
WC_CODES.set('8820', 'Attorney-All Empls & Clerical Messengers Driv')
WC_CODES.set('8824', 'Health Care Employees')
WC_CODES.set('8825', 'Food Service Employees')
WC_CODES.set('8826', 'All Other Employees')
WC_CODES.set('8829', 'Nursing Home-All Employees')
WC_CODES.set('8831', 'Hospital-Veterinary & Drivers')
WC_CODES.set('8832', 'Physician & Clerical')
WC_CODES.set('8833', 'Hospital: Professional Employees')
WC_CODES.set('8835', 'Nursing Home Health, Public-All Employees')
WC_CODES.set('8837', 'Welfare Organization-All Operations & Drivers')
WC_CODES.set('8842', 'Group Homes - All Employees, Salespersons & Drivers')
WC_CODES.set('8861', 'Charitable/Welfare Org Prof/Cler')
WC_CODES.set('8864', 'Social Services Org-All Employees, Salespersons & Drivers')
WC_CODES.set('8868', 'Schools: Professional Employees & Clerical')
WC_CODES.set('8869', 'Professional Employees & clerical')
WC_CODES.set('8871', 'Clerical telecommuter employees')
WC_CODES.set('8872', 'Outside Sales')
WC_CODES.set('8901', 'Telephone/Telegraph Co-Off Emp/Clerical')
WC_CODES.set('9012', 'Bld oper-clerical/sales/prof serv.')
WC_CODES.set('9014', 'Buildings-Operations by Contractor')
WC_CODES.set('9015', 'Building NOC-Operation by Owner')
WC_CODES.set('9016', 'Amusement Park Operation & Drivers')
WC_CODES.set('9019', 'Bridge Operation & Drivers')
WC_CODES.set('9032', 'Apartment House Oper.')
WC_CODES.set('9033', 'Housing Authority & Clerical Saleprsns Driver')
WC_CODES.set('9040', 'Hospital-All Other Employees')
WC_CODES.set('9044', 'Casino Gambling Hotel: All Employees & Clerical, Salespersons, Drivers')
WC_CODES.set('9052', 'Hotel-All Other Employees & Saleprsns Drivers')
WC_CODES.set('9058', 'Hotel-Restaurant Employees')
WC_CODES.set('9059', 'All other employees & clerical')
WC_CODES.set('9060', 'Club-Country & Clerical')
WC_CODES.set('9061', 'Club NOC & Clerical')
WC_CODES.set('9062', 'Casino Gambling: All Employees & Clerical Salespersons, Drivers')
WC_CODES.set('9063', 'Health Institute & Clerical')
WC_CODES.set('9077F', 'U.S. Armed Service Risk-All Empls & Drivers')
WC_CODES.set('9079', 'Restaurant NOC')
WC_CODES.set('9082', 'Restaurant')
WC_CODES.set('9083', 'Restaurant-Fast Food')
WC_CODES.set('9084', 'Bar,lounge, or tavern')
WC_CODES.set('9088', 'Rocket/Missile Testing/Launching & Drivers')
WC_CODES.set('9089', 'Billiard Hall')
WC_CODES.set('9093', 'Bowling Lane')
WC_CODES.set('9101', 'School-All Other Employees')
WC_CODES.set('9102', 'Park NOC-All Employees & Drivers')
WC_CODES.set('9108', 'Seat Surcharge')
WC_CODES.set('9110', 'Charitable/Welfare Org for all Others')
WC_CODES.set('9154', 'Theater NOC-All Other Employees')
WC_CODES.set('9156', 'Theater NOC-Players, Entertainers/Musicians')
WC_CODES.set('9178', 'Athletic Team/Park-Noncontact Sports')
WC_CODES.set('9179', 'Athletic Team or Park-Contact Sports')
WC_CODES.set('9180', 'Amusement Device Operation NOC & Drivers')
WC_CODES.set('9182', 'Athletic Team or Park-Operation & Drivers')
WC_CODES.set('9186', 'Amusement Device Opr Traveling')
WC_CODES.set('9220', 'Cemetery Operations & Drivers')
WC_CODES.set('9402', 'Street Cleaning & Drivers')
WC_CODES.set('9403', 'Garbage Collection & Drivers')
WC_CODES.set('9410', 'Municipal Township Country/State Empl NOC')
WC_CODES.set('9501', 'Painting-Shop Only & Drivers')
WC_CODES.set('9505', 'Painting-Automobile Bodies')
WC_CODES.set('9516', 'Radio/TV/Video/Audio Equip Installation')
WC_CODES.set('9519', 'Household Appliances-Elec-Installation & Driv')
WC_CODES.set('9521', 'House Furnishing Installation NOC & Upholstng')
WC_CODES.set('9522', 'Upholstering')
WC_CODES.set('9529', 'Construction Elevator Installation & Drivers')
WC_CODES.set('9534', 'Mobile Crane/Hoisting Serv Contr-NOC')
WC_CODES.set('9535', 'just because')
WC_CODES.set('9545', 'Bill Posting & Drivers')
WC_CODES.set('9549', 'Advertising Company & Drivers')
WC_CODES.set('9552', 'Sign Mfg.-Erection & Drivers')
WC_CODES.set('9586', 'Barber Shop, Beauty Shop')
WC_CODES.set('9600', 'Taxidermist')
WC_CODES.set('9620', 'Funeral Director & Drivers')
WC_CODES.set('9984', 'Atomic Energy: Project Work')
WC_CODES.set('9985', 'Atomic Energy: Radiation Exposure NOC')
WC_CODES.set('8603', 'Architect & Engineer-Clerical')
WC_CODES.set('9554', 'Sign Installation, Maintenance, Repair or Removal away from shop & Drivers')

export { WC_CODES }
